import { render, staticRenderFns } from "./orderlist-view.vue?vue&type=template&id=d461a6b0&scoped=true&"
import script from "./orderlist-view.vue?vue&type=script&lang=js&"
export * from "./orderlist-view.vue?vue&type=script&lang=js&"
import style0 from "./orderlist-view.vue?vue&type=style&index=0&id=d461a6b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d461a6b0",
  null
  
)

export default component.exports